// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 32452) return "static/chunks/" + chunkId + ".4834a529f4e316b8.js";
	if (chunkId === 96820) return "static/chunks/" + chunkId + ".0e3db257cb7fe73f.js";
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 52084 ? "9b0008ae" : chunkId) + "-" + {"14216":"0e078252b3bccb75","26028":"0e489d79ebceac53","30447":"c6641e8b52e7436e","52084":"29320d4f221d2529","58316":"5bb104bd55a9ff66","78363":"6abbc569821cb585"}[chunkId] + ".js";
};